import { Table } from 'antd';
import { orderBy } from 'lodash';
import React from 'react';

import { ImageThumbnail } from '../../../../components/ImageThumbnail';
import { typeColumn } from '../../../AccessPoint/columns';
import { AccessPointModel } from '../../../AccessPoint/model';
import {
  EmergencyPlanWithIcon,
} from '../../../EmergencyScenarioAccessPoint/components/EmergencyPlanWithIcon';

import { EmergencyScenarioSyncStatusColumn } from './EmergencyScenarioSyncStatusColumn';
import type { IEmergencyScenarioMonitoringProps } from './typings';

export const EmergencyScenarioAccessPointMonitoring: React.FC<
  IEmergencyScenarioMonitoringProps
> = (props) => {
  const { monitoredAccessPoints } = props.emergencyScenarioMonitoring;

  const sortedMonitoredAccessPoints = orderBy(monitoredAccessPoints, [
    a => a.syncStatus,
    a => a.emergencyPlan,
    a => a.accessPoint.name,
  ], ['desc', 'asc', 'asc']);

  return (
    <Table
      dataSource={sortedMonitoredAccessPoints}
      pagination={false}
      rowKey={({ accessPoint }) => accessPoint.accessPointId}
      columns={[
        {
          title: 'Access Point',
          render: (_, { accessPoint }) => AccessPointModel.routes.renderRowLink(accessPoint),
        },
        {
          key: 'Image',
          render: (_, { accessPoint }) => (
            <ImageThumbnail title={accessPoint.name} image={accessPoint.image} />
          ),
        },
        {
          title: 'Type',
          render: (_, { accessPoint }) => typeColumn.render(accessPoint as any),
        },
        {
          title: 'Emergency Plan',
          render: (_, { emergencyPlan }) => {
            return <EmergencyPlanWithIcon emergencyPlan={emergencyPlan} />;
          },
        },
        {
          title: 'Status',
          render: (_, monitoredAccessPoint) => (
            <EmergencyScenarioSyncStatusColumn {...monitoredAccessPoint} />
          ),
        },
      ]}
    />
  );
};
